<template>

  <form
      class="bg-[#3E5463] bg-opacity-65 w-full h-[calc(100vh-91px)] flex justify-center items-end absolute inset-0 rounded-[20px] px-[12px] py-[19px]" @submit.prevent="login">
    <div class="bg-white px-[19px] py-[13px] w-full rounded-[20px] h-[190.4px] mb-[26px]">
      <div class="text-[22px] sm:text-[25px] font-bold text-[#35474B] uppercase mb-[7.4px]">
        {{lang === 'en' ? 'Login' : 'تسجيل الدخول'}}
      </div>
      <div
          class="h-[59px] px-[15.5px] pt-[6.5px] mb-[40px] w-full rounded-[10px] bg-white shadow-[0_4px_3px_0_#E0E9F0]">
        <label for="phone" class="text-[16px] font-light text-[#C6A798] block"> {{lang === 'en' ? 'Mobile number' : 'رقم الهاتف المحمول'}} </label>
        <input id="phone" type="text" name="phone" class="block outline-0 border-0 bg-transparent text-[#35474B] w-full"
               autoComplete="off" v-model="phone" @keypress="validateNumber"/>
        <div v-if="phoneError" class="text-red-700 my-2">{{phoneError}}</div>
      </div>
      <button type="submit"
              class="rounded-[12px] w-full h-[64px] bg-[#C6A798] hover:bg-[#B28F85] duration-500 text-white uppercase text-[18px] sm:text-[21px] font-bold -mb-[2px]"
              v-if="!loading">
        <span class="inline-block mt-[10px]">
          {{lang === 'en' ? 'Login' : 'تسجيل الدخول'}}
        </span>
      </button>
      <button type="button" :disabled="true"
              class="rounded-[12px] w-full h-[64px] bg-[#C6A798] text-white uppercase text-[18px] sm:text-[21px] font-bold -mb-[2px]" v-if="loading">
        <span class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
      </button>
    </div>
  </form>

</template>

<script>



import ApiService from "@/service/apiService";

export default {
  data() {
    return {
      lang: window?.core?.lang,
      phone: '',
      loading: false,
      phoneError: null
    }
  },

  mounted() {

  },
  methods: {

    async login() {
      try {
        this.phoneError = null;
        if(!this.phone){
          this.phoneError = `${this.lang === 'en' ? 'Phone number is required.' : 'رقم الهاتف مطلوب.'}`;
          return;
        }
        this.loading = true;
        const url = `/Login`;
        const response = await ApiService.post(url, {phone: this.phone});
        if(response?.data?.error?.phone.length > 0){
          this.phoneError = response?.data?.error?.phone[0];
          return;
        }
        if(response.data.status === 200){
          this.$emit('handleLogin', {phone: this.phone});
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.loading = false;
      }
    },

    validateNumber(evt) {
      evt.stopPropagation();
      var theEvent = evt || window.event;

      // Handle paste
      if (theEvent.type === 'paste') {
        // @ts-ignore
        key = event.clipboardData.getData('text/plain');
      } else {
        // Handle key press
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
      }
      var regex = /^\d*\.?\d*$/;
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  }
}

</script>